import type { ColoredOption } from './display';

// approximation pour CA régie : nb_devs × TJM × 20j × engagement

// ── CRM / Affaires ──────────────────────────────────────────────────────────
/** Statut d'une affaire dans le pipeline commercial. */
export type DealStatus =
  | 'a_travailler'
  | 'chiffrage_en_cours'
  | 'chiffrage_envoye'
  | 'devis_accepte'
  | 'en_cours'
  | 'termine'
  | 'suspendu'
  | 'sans_suite'
  | 'non_retenu';
export const DEAL_STATUSES: ColoredOption<DealStatus>[] = [
  { key: 'a_travailler', label: 'À travailler', color: '#8B5CF6' },
  { key: 'chiffrage_en_cours', label: 'Chiffrage en cours', color: '#D9A521' },
  { key: 'chiffrage_envoye', label: 'Chiffrage envoyé', color: '#10B981' },
  { key: 'devis_accepte', label: 'Devis accepté', color: '#1D9E75' },
  { key: 'en_cours', label: 'En cours', color: '#3B82F6' },
  { key: 'termine', label: 'Terminé', color: '#047857' },
  { key: 'suspendu', label: 'Suspendu', color: '#EC4899' },
  { key: 'sans_suite', label: 'Sans suite', color: '#94A3B8' },
  { key: 'non_retenu', label: 'Non retenu', color: '#F97316' },
];
export const DEAL_STATUS_MAP = Object.fromEntries(DEAL_STATUSES.map((s) => [s.key, s])) as Record<
  DealStatus,
  ColoredOption<DealStatus>
>;
export const DEAL_LOST_STATUSES: readonly string[] = ['sans_suite', 'non_retenu'];
// Statuts comptant dans le C.A cumulé d'un contact (devis conclu, en cours d'exécution ou livré)
export const DEAL_WON_STATUSES: readonly string[] = ['devis_accepte', 'en_cours', 'termine'];
export const DEAL_CLOSED_STATUSES: readonly string[] = ['suspendu', 'sans_suite', 'non_retenu'];
// Statuts depuis lesquels une affaire peut être convertie en projet (affaire gagnée, pas encore
// terminée).
export const DEAL_CONVERTIBLE_STATUSES: readonly string[] = ['devis_accepte', 'en_cours'];
// statuts qui demandent un motif
export const DEAL_TYPES = [
  'Logiciel SAAS',
  'E-commerce',
  'Application mobile',
  'ERP',
  'Maintenance',
  'Refonte logiciel',
  'Audit',
  'Autre',
];
export const DEAL_ORIGINS = [
  'SEA',
  'Site web',
  'Bouche à oreille',
  'Réseau',
  'Linkedin',
  'Prospection',
  "Appel d'offre",
  'Sortlist',
  'Les bons freelances',
  'Autre',
];
export const DEAL_CLOSE_REASONS = [
  'Prix trop élevé',
  'Délai trop long',
  "Choix d'un concurrent",
  'Pas de budget',
  'Sans réponse',
  'Projet annulé',
  'Autre',
];
// Saisie d'un motif de clôture absent de la liste (fiche affaire et clôture depuis le pipeline).
export const NEW_CLOSE_REASON_DIALOG = {
  title: 'Nouveau motif de clôture',
  confirmLabel: 'Ajouter',
};
export const DEAL_ACTIONS = [
  'Appel',
  'Mail',
  'RDV',
  'Relance',
  'Préparer le chiffrage',
  'Envoyer le chiffrage',
];
export const DEFAULT_DAILY_RATE = 600;
// Client "Interne" : seul client pour lequel une phase peut être créée hors CRM (suivi de temps
// interne, pas un projet commercial). Tout autre projet doit passer par une affaire convertie —
// évite que le CA cumulé/par année des contacts ne devienne à nouveau incomplet.
export const INTERNAL_CLIENT_ID = 'xqi3uqp';

// Icône de chaque type d'action commerciale (Tabler Icons).
export const ACTIVITY_ICONS: Record<string, string> = {
  Appel: 'ti-phone',
  Mail: 'ti-mail',
  RDV: 'ti-calendar-event',
  Relance: 'ti-refresh',
  'Préparer le chiffrage': 'ti-file-pencil',
  'Envoyer le chiffrage': 'ti-send',
};
